import { render, staticRenderFns } from "./SDetailInventoriesProductComp.vue?vue&type=template&id=0439e066&"
import script from "./SDetailInventoriesProductComp.vue?vue&type=script&lang=js&"
export * from "./SDetailInventoriesProductComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports